import {
  createDepositWithdrawOperation,
  applyDepositWithdrawOperation,
  decryptResponseMessages,
} from "../../utils/apiClient";

/**
 * Create IB deposit/withdraw operation to transfer funds **from** a client
 * to the current IB/agent.
 *
 * BODY:
 *  - AMOUNT: number
 *  - WALLET_ID: number
 *  - USER_ID: number (client ID)
 *  - NOTE: string | null
 *  - TYPE: number (defaults to 5 as per backend spec for "from client")
 *
 * Uses the same encrypted MESSAGES + Authorization header strategy
 * as other money-operation helpers in apiClient.
 */
export const createTransferFromClientOperation = async ({
  amount,
  walletId,
  userId,
  note = "",
  type = 5,
  options = {},
} = {}) => {
  const response = await createDepositWithdrawOperation(
    { amount, walletId, userId, note, type },
    options
  );

  // Prefer decryptedData from postEncryptedJson helper when available
  if (response && response.decryptedData) {
    return response.decryptedData;
  }

  if (response?.data) {
    const parsed = await decryptResponseMessages(response.data);
    if (parsed) return parsed;
  }

  if (response && response.data) {
    return response.data;
  }
  return response;
};

/**
 * Apply IB deposit/withdraw operation (from client) using password (PIN)
 * and TRANSACTION_ID.
 *
 * Mirrors the cash-in "apply" behavior but targets the
 * /v1/user/apply-deposit-withdraw-operation endpoint.
 */
export const applyTransferFromClientOperation = async ({
  transactionId,
  password,
  options = {},
} = {}) => {
  const response = await applyDepositWithdrawOperation(
    transactionId,
    password,
    options
  );

  if (response && response.decryptedData) {
    return response.decryptedData;
  }
  if (response && response.data) {
    return response.data;
  }
  return response;
};

export default {
  createTransferFromClientOperation,
  applyTransferFromClientOperation,
};

